export const SOURCE = 'jiraUserSegmentationScreen';
export const VISITED_USER_SEG_PARAM = 'visitedUserSeg';
